import React from "react";

// Bar-graph filter list: each option is a full-width clickable row with a fill
// bar sized to its count (relative to the list max), the label + count on top,
// and a left accent stripe + tinted fill when selected. Replaces the old
// checkbox OptionList. Items are `{item, count}` (count optional — availability
// and seat rows have no facet count, so their bar/count are simply omitted).
//
// `minRows` (optional) pads the list with presentation-only placeholder rows up
// to that count, so cards with fewer real options still reserve a consistent
// height (paired with SidebarSection's fixed-row viewport). Placeholders carry
// no label/count/handler, are non-interactive, and are hidden from assistive
// tech — they only reserve vertical space and are never part of filter state.
// `getSecondary` (optional) returns a right-aligned secondary value shown before
// the count — used by Installed Options to display each package's price. It only
// renders when the callback returns a non-null value, so sections that don't
// pass it (every other facet) are unchanged.
export function BarFilter({items, isSelected, onToggle, getLabel, renderDot, minRows = 0, getSecondary}) {
    const list = items || []
    const maxCount = Math.max(1, ...list.map((i) => i.count || 0))
    const placeholders = Math.max(0, minRows - list.length)

    return (
        <div className="bar-filter">
            {list.map((item) => {
                const selected = isSelected(item.item)
                const hasCount = item.count !== undefined && item.count !== null
                const pct = hasCount ? ((item.count || 0) / maxCount) * 100 : 0
                const secondary = getSecondary ? getSecondary(item) : null
                return (
                    <div
                        key={item.item}
                        className={`bar-row${selected ? ' selected' : ''}`}
                        onClick={() => onToggle(item.item)}
                    >
                        <div className="bar-fill" style={{width: `${pct}%`}}/>
                        <div className="bar-content">
                            <span className="bar-label">
                                {renderDot && renderDot(item)}
                                {getLabel ? getLabel(item) : item.item}
                            </span>
                            {secondary != null && <span className="bar-price">{secondary}</span>}
                            {hasCount && <span className="bar-count">{item.count}</span>}
                        </div>
                    </div>
                )
            })}
            {Array.from({length: placeholders}).map((_, i) => (
                <div
                    key={`__placeholder-${i}`}
                    className="bar-row bar-row--placeholder"
                    aria-hidden="true"
                />
            ))}
        </div>
    );
}
